<!-- <app-header-actions></app-header-actions> -->
<div class="frame">
    <iframe width="100%" height="{{dynamicHeight}}px" [src]="url | safe" style="Border-style: hidden;"></iframe>
</div>